export const THEMES = {
  default: {
    name: "Default",

    bgPrimary: "#090d16",
    bgSurface: "#111827",
    bgSurfaceElevated: "#1f2937",
    bgInput: "#172033",

    accentPrimary: "#3b82f6",
    accentHover: "#2563eb",
    accentGlow: "rgba(59, 130, 246, 0.25)",

    textMain: "#f9fafb",
    textSub: "#9ca3af",
    textMuted: "#6b7280",

    borderColor: "#1f2937",
    borderFocus: "#3b82f6",

    headerBg: "#080d17",
    sidebarBg: "#111827",
    sidebarActive: "#3b82f6",

    cardBg: "#111827",
    inputBg: "#172033",

    isDark: true,
  },

  bright: {
    name: "Bright",

    bgPrimary: "#f8fafc",
    bgSurface: "#ffffff",
    bgSurfaceElevated: "#f1f5f9",
    bgInput: "#ffffff",

    accentPrimary: "#2563eb",
    accentHover: "#1d4ed8",
    accentGlow: "rgba(37, 99, 235, 0.18)",

    textMain: "#0f172a",
    textSub: "#475569",
    textMuted: "#64748b",

    borderColor: "#e2e8f0",
    borderFocus: "#2563eb",

    headerBg: "#ffffff",
    sidebarBg: "#ffffff",
    sidebarActive: "#2563eb",

    cardBg: "#ffffff",
    inputBg: "#ffffff",

    isDark: false,
  },

  ocean: {
    name: "Ocean Blue",

    bgPrimary: "#f0f9ff",
    bgSurface: "#ffffff",
    bgSurfaceElevated: "#e0f2fe",
    bgInput: "#ffffff",

    accentPrimary: "#0ea5e9",
    accentHover: "#0284c7",
    accentGlow: "rgba(14, 165, 233, 0.18)",

    textMain: "#0f172a",
    textSub: "#475569",
    textMuted: "#64748b",

    borderColor: "#bae6fd",
    borderFocus: "#0ea5e9",

    headerBg: "#ffffff",
    sidebarBg: "#ffffff",
    sidebarActive: "#0ea5e9",

    cardBg: "#ffffff",
    inputBg: "#ffffff",

    isDark: false,
  },

  emerald: {
    name: "Emerald",

    bgPrimary: "#f0fdf4",
    bgSurface: "#ffffff",
    bgSurfaceElevated: "#dcfce7",
    bgInput: "#ffffff",

    accentPrimary: "#10b981",
    accentHover: "#059669",
    accentGlow: "rgba(16, 185, 129, 0.18)",

    textMain: "#0f172a",
    textSub: "#475569",
    textMuted: "#64748b",

    borderColor: "#bbf7d0",
    borderFocus: "#10b981",

    headerBg: "#ffffff",
    sidebarBg: "#ffffff",
    sidebarActive: "#10b981",

    cardBg: "#ffffff",
    inputBg: "#ffffff",

    isDark: false,
  },

  sunset: {
    name: "Sunset",

    bgPrimary: "#fffbeb",
    bgSurface: "#ffffff",
    bgSurfaceElevated: "#fef3c7",
    bgInput: "#ffffff",

    accentPrimary: "#f59e0b",
    accentHover: "#d97706",
    accentGlow: "rgba(245, 158, 11, 0.18)",

    textMain: "#0f172a",
    textSub: "#475569",
    textMuted: "#64748b",

    borderColor: "#fde68a",
    borderFocus: "#f59e0b",

    headerBg: "#ffffff",
    sidebarBg: "#ffffff",
    sidebarActive: "#f59e0b",

    cardBg: "#ffffff",
    inputBg: "#ffffff",

    isDark: false,
  },

  rose: {
    name: "Rose",

    bgPrimary: "#fff1f2",
    bgSurface: "#ffffff",
    bgSurfaceElevated: "#ffe4e6",
    bgInput: "#ffffff",

    accentPrimary: "#f43f5e",
    accentHover: "#e11d48",
    accentGlow: "rgba(244, 63, 94, 0.18)",

    textMain: "#0f172a",
    textSub: "#475569",
    textMuted: "#64748b",

    borderColor: "#fecdd3",
    borderFocus: "#f43f5e",

    headerBg: "#ffffff",
    sidebarBg: "#ffffff",
    sidebarActive: "#f43f5e",

    cardBg: "#ffffff",
    inputBg: "#ffffff",

    isDark: false,
  },

  purple: {
    name: "Brand Purple",

    bgPrimary: "#faf5ff",
    bgSurface: "#ffffff",
    bgSurfaceElevated: "#f3e8ff",
    bgInput: "#ffffff",

    accentPrimary: "#7c3aed",
    accentHover: "#6d28d9",
    accentGlow: "rgba(124, 58, 237, 0.18)",

    textMain: "#0f172a",
    textSub: "#475569",
    textMuted: "#64748b",

    borderColor: "#ddd6fe",
    borderFocus: "#7c3aed",

    headerBg: "#ffffff",
    sidebarBg: "#ffffff",
    sidebarActive: "#7c3aed",

    cardBg: "#ffffff",
    inputBg: "#ffffff",

    isDark: false,
  },

  dark: {
    name: "Dark Mode",

    bgPrimary: "#020617",
    bgSurface: "#0f172a",
    bgSurfaceElevated: "#1e293b",
    bgInput: "#172033",

    accentPrimary: "#8b5cf6",
    accentHover: "#7c3aed",
    accentGlow: "rgba(139, 92, 246, 0.25)",

    textMain: "#f8fafc",
    textSub: "#94a3b8",
    textMuted: "#64748b",

    borderColor: "#334155",
    borderFocus: "#8b5cf6",

    headerBg: "#020617",
    sidebarBg: "#0f172a",
    sidebarActive: "#8b5cf6",

    cardBg: "#0f172a",
    inputBg: "#172033",

    isDark: true,
  },
};